import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';

import { SvcModalActionPlanWorkflowRequest } from '../interfaces/svc-modal-action-plan.interface';

@Injectable({
  providedIn: 'root',
})
export class SvcActionPlanApprovalService {
  readonly #http = inject(HttpClient);
  readonly #appConfig = inject(AppEnvironmentConfig);

  readonly #api = this.#appConfig.APIs.apiUrlActionPlan;

  public sendToApproval(actionPlanId: number, request: SvcModalActionPlanWorkflowRequest = {}): Observable<unknown> {
    return this.#http.post<unknown>(
      `${this.#api}/ActionPlan/${actionPlanId}/send-to-approval`,
      request,
      { headers: this.#headers() }
    );
  }

  public complete(actionPlanId: number, request: SvcModalActionPlanWorkflowRequest = {}): Observable<unknown> {
    return this.#http.post<unknown>(
      `${this.#api}/ActionPlan/${actionPlanId}/complete`,
      request,
      { headers: this.#headers() }
    );
  }

  public approve(actionPlanId: number, request: SvcModalActionPlanWorkflowRequest = {}): Observable<unknown> {
    return this.#http.post<unknown>(
      `${this.#api}/ActionPlan/${actionPlanId}/approve`,
      request,
      { headers: this.#headers() }
    );
  }

  public reject(actionPlanId: number, request: SvcModalActionPlanWorkflowRequest = {}): Observable<unknown> {
    return this.#http.post<unknown>(
      `${this.#api}/ActionPlan/${actionPlanId}/reject`,
      request,
      { headers: this.#headers() }
    );
  }

  public reopen(actionPlanId: number, request: SvcModalActionPlanWorkflowRequest = {}): Observable<unknown> {
    return this.#http.post<unknown>(
      `${this.#api}/ActionPlan/${actionPlanId}/reopen`,
      request,
      { headers: this.#headers() }
    );
  }

  #headers(): { EnvironmentUrl: string } {
    const fromStorage = typeof localStorage !== 'undefined' ? localStorage.getItem('environmentUrl') : null;
    const fromWindow = typeof window !== 'undefined' ? window.location.origin : '';
    return { EnvironmentUrl: fromStorage || fromWindow };
  }
}
